<template>
  <div class="map-container">
    <div ref="map" class="google-map"></div>
  </div>
</template>

<script>
export default {
  props: {
    markersData: {
      type: Array,
      required: true,
    },
    zoom: {
      type: Number,
      default: 14,
    },
  },

  data() {
    return {
      map: null,
      markers: [],
      geocoder: null,
      infoWindow: null,
    };
  },

  watch: {
    markersData: {
      handler() {
        this.renderMarkers();
      },
      deep: true,
    },
  },

  mounted() {
    this.initMap();
  },

  methods: {
    initMap() {
      if (!window.google || !window.google.maps) {
        console.error('Google Maps API não carregada');
        return;
      }

      this.map = new google.maps.Map(this.$refs.map, {
        center: { lat: 0, lng: 0 },
        zoom: this.zoom,
        mapId: process.env.VUE_APP_GOOGLE_MAP_ID,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      this.geocoder = new google.maps.Geocoder();
      this.infoWindow = new google.maps.InfoWindow();

      this.renderMarkers();
    },

    renderMarkers() {
      if (!this.map || !this.markersData.length) return;

      this.markers.forEach(marker => marker.map = null);
      this.markers = [];

      const bounds = new google.maps.LatLngBounds();

      this.markersData.forEach((item) => {
        const position = new google.maps.LatLng(item.latitude, item.longitude);
        const pinColor = item.cor || "#4285F4";

        const pin = new google.maps.marker.PinElement({
          background: pinColor,
          borderColor: "#000",
          glyphColor: "#000",
          scale: 0.7,
        });

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position,
          content: pin.element,
          gmpDraggable: true,
        });

        marker._addressKey = item;

        marker.addListener("dragend", (event) => {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();

          this.geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === "OK" && results[0]) {
              this.$emit("onPositionChanged", {
                addressKey: marker._addressKey,
                lat,
                lng,
                endereco: this.extrairEnderecoCompleto(results[0].address_components),
              });
            } else {
              console.warn("Geocoder falhou:", status);
            }
          });
        });

        marker.addListener("click", () => {
          this.openInfoWindow(marker);
        });

        this.markers.push(marker);
        bounds.extend(position);
      });

      this.map.fitBounds(bounds);
    },

    renderAddressDetails(address) {
      const fields = [
        { label: "Descrição", value: address.descricao },
        { label: "Logradouro", value: address.logradouro },
        { label: "Número", value: address.numero },
        { label: "Bairro", value: address.bairro },
        { label: "Cidade", value: address.cidade },
        { label: "Estado", value: address.estado },
        { label: "CEP", value: address.cep },
      ];

      const detailsHtml = fields
          .filter(field => field.value != null && field.value !== '')
          .map(field => `<p><strong>${field.label}:</strong> ${field.value}</p>`)
          .join('');

      return `
        <div>
          <h4>Detalhes do Endereço</h4>
          ${detailsHtml}
        </div>
      `;
    },

    openInfoWindow(marker) {
      const address = marker._addressKey;
      const content = this.renderAddressDetails(address);
      this.infoWindow.setContent(content);
      this.infoWindow.open(this.map, marker);
    },

    extrairEnderecoCompleto(components) {
      const get = (type) =>
          components.find(c => c.types.includes(type))?.long_name || '';

      return {
        numero: get('street_number'),
        rua: get('route'),
        bairro: get('sublocality') || get('neighborhood'),
        cidade: get('administrative_area_level_2'),
        estado: get('administrative_area_level_1'),
        cep: get('postal_code'),
        pais: get('country'),
      };
    },
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 500px;
  padding-bottom: 2rem;
}

.google-map {
  width: 100%;
  height: 100%;
}
</style>
